module.exports = __webpack_public_path__ + "static/media/angela-icon.146d8ddb.jpg";